<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>post_add</mat-icon>
        <div>Documentos</div>
      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card>
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>cast</mat-icon>
          <div>Solicitado</div>
        </ng-template>

        <div class='toolbar-tab'>
          <input class='filter' matInput (keyup)="applyFilterPending($event.target.value)" placeholder='filtro'
            autocomplete="off">
          <!--
            <a mat-button (click)="openUploadDialog(null)" style='width:60px;'>
              <mat-icon color='primary'>add_circle_outline</mat-icon>
            </a>
            -->
        </div>

        <!-- TABLE -->
        <mat-table [dataSource]="pendingDataSource" #pendingSort="matSort" matSort matSortDisableClear=true>

          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.2em; margin-top:10px;'>post_add</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- member_name Column -->
          <ng-container matColumnDef="member_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Usuário </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.member_name }} </mat-cell>
          </ng-container>

          <!-- product_name Column -->
          <ng-container matColumnDef="product_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Produto </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.product_name }} </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openUploadDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>



          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedPendingColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedPendingColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

        <mat-paginator [pageSizeOptions]="[9, 13, 26, 50]"></mat-paginator>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>cast_connected</mat-icon>
          <div>Recebidos</div>
        </ng-template>

        <div class='toolbar-tab'>
          <input class='filter' matInput (keyup)="applyFilterSent($event.target.value)" placeholder='filtro'
            autocomplete="off">
        </div>

        <!-- TABLE -->
        <mat-table [dataSource]="sentDataSource" #sentSort="matSort" matSort matSortDisableClear=true>

          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.2em; margin-top:10px;'>post_add</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- member_name Column -->
          <ng-container matColumnDef="member_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Usuário </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.member_name }} </mat-cell>
          </ng-container>

          <!-- product_name Column -->
          <ng-container matColumnDef="product_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Produto </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.product_name }} </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedSentColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedSentColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

         <mat-paginator [pageSizeOptions]="[9, 13, 26, 50]"></mat-paginator>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>cast_for_education</mat-icon>
          <div>Aprovados</div>
        </ng-template>

        <div class='toolbar-tab'>
          <input class='filter' matInput (keyup)="applyFilterApproved($event.target.value)" placeholder='filtro'
            autocomplete="off">

        </div>

        <!-- TABLE -->
        <mat-table [dataSource]="approvedDataSource" #approvedSort="matSort" matSort matSortDisableClear=true>
          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.2em; margin-top:10px;'>post_add</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- member_name Column -->
          <ng-container matColumnDef="member_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Usuário </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.member_name }} </mat-cell>
          </ng-container>

          <!-- product_name Column -->
          <ng-container matColumnDef="product_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Produto </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.product_name }} </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedApprovedColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedApprovedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

         <mat-paginator [pageSizeOptions]="[9, 13, 26, 50]"></mat-paginator>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">folder</mat-icon>
          <div>Pastas</div>
        </ng-template>

        <div>

          <div style="margin: 10px; background-color: whitesmoke;">
            <a mat-button (click)="openFolderDialog(null)" style='width:60px;'>
              <mat-icon color='primary'>add_circle_outline</mat-icon>
            </a>
            <a mat-button (click)="openMoveDialog()" style='width:60px;'>
              <mat-icon color='primary'>swap_vert</mat-icon>
            </a>
          </div>

          <div *ngFor="let folder of folders">

            <div style="margin: 5px; padding: 5px;">
              <div  style="display: flex; flex-direction: row; justify-content: space-between; background-color: whitesmoke;">
                <div style="width: 400px;">
                  <a mat-button (click)="toggle_list(folder.id)">
                    {{folder.name}}
                  </a>
                </div>
                <div *ngIf="folder.id !=='sETMnBqEPJB6ky0paoF4'"> <!--folder default é imutável -->
                  <a mat-button (click)="openFolderDialog(folder)" style='width:60px;'>
                    <mat-icon class="icon-info">
                      info_outline
                    </mat-icon>
                  </a>
                  <a mat-button (click)="openFolderDeleteDialog(folder)" style='width:60px;'>
                    <mat-icon class="icon-delete">
                      delete_outline
                    </mat-icon>
                  </a>

                </div>
              </div>
            </div>

            <div id={{folder.id}} style="display: none; width: 80%; ">

              <div *ngFor="let file of folder.files">
                <div style="width: 100%; margin: 5px 5px 5px 30px; padding: 10px; background-color: whitesmoke;">

                  <div>
                    {{file.member_name}}
                  </div>

                  <div style="margin-left: 20px;">
                    <mat-checkbox class="staff-width" color='primary' [(ngModel)]="file.selected">
                    </mat-checkbox>

                    <a (click)='goToLink(file.url)' style="cursor: pointer; color: blue">
                      {{file.filename}}
                    </a>

                    <div>
                      <span *ngIf='file.approved'>
                        Aprovado
                      </span>
                      <span *ngIf='!file.approved'>
                        Aguardando
                      </span>

                      <span> - {{file.date.seconds*1000 | date: 'dd/MM/yyyy'}} </span>
                    </div>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </mat-tab>
      
    </mat-tab-group>

  </mat-card>

</div>